module.exports = __webpack_public_path__ + "img/questionW.28c1ae6a.svg";